// 内容管理 =》 元素管理
export default {
  BASE_URL: '/content',
  api: [
    {
      name: 'getEleCatalogs',
      method: 'GET',
      desc: '获取页签',
      path: '/eleCatalog/getEleCatalogs'
    },
    {
      name: 'getCatalogs',
      method: 'GET',
      desc: '获取分组',
      append: true,
      path: '/eleCatalog/getCatalogs'
    },
    {
      name: 'modifyEleCatalog',
      method: 'POST',
      desc: '修改分组名称',
      path: '/eleCatalog/modifyEleCatalog'
    },
    {
      name: 'changeEleCatalogPosition',
      method: 'POST',
      desc: '改变分组顺序',
      path: '/eleCatalog/changeEleCatalogPosition'
    },
    {
      name: 'addEleCatalog',
      method: 'POST',
      desc: '新增',
      path: '/eleCatalog/addEleCatalog'
    },
    {
      name: 'checkCatalogName',
      method: 'GET',
      desc: '校验相册同名',
      path: '/eleCatalog/checkCatalogName'
    },
    {
      name: 'deleteImgEleCatalog',
      method: 'GET',
      desc: '删除相册',
      append: true,
      path: '/eleCatalog/deleteImgEleCatalog'
    },
    {
      name: 'allCatalogList',
      method: 'GET',
      desc: '左侧相册列表展示',
      path: '/eleCatalog/allCatalogList'
    },
    {
      name: 'imgCatalogList',
      method: 'GET',
      desc: '点击父级点展示相册中图片列表',
      path: '/eleCatalog/imgCatalogList'
    },
    {
      name: 'checkCatalogName',
      method: 'GET',
      desc: '校验相册同名',
      path: '/eleCatalog/checkCatalogName'
    },
    {
      name: 'checkCatalogCover',
      method: 'POST',
      desc: '检测相册封面',
      append: true,
      path: '/eleCatalog/checkCatalogCover'
    },
    {
      name: 'addImg',
      method: 'POST',
      desc: '上传图片',
      path: '/eleImg/addImg'
    },
    {
      name: 'deleteImg',
      method: 'GET',
      desc: '删除图片',
      append: true,
      path: '/eleImg/deleteImg'
    },
    {
      name: 'imgDetail',
      method: 'GET',
      desc: '图片详情-预览图片',
      path: '/eleImg/imgDetail'
    },
    {
      name: 'renameImg',
      method: 'POST',
      desc: '图片重命名',
      path: '/eleImg/renameImg'
    },
    {
      name: 'checkImgName',
      method: 'GET',
      desc: '校验图片重命名',
      path: '/eleImg/checkImgName'
    },
    {
      name: 'setImgCatalogCover',
      method: 'POST',
      desc: '设置封面',
      path: '/eleCatalog/setImgCatalogCover'
    },
    {
      name: 'imgList',
      method: 'GET',
      desc: '图片列表',
      path: '/eleImg/imgList'
    },
    {
      name: 'moveImg',
      method: 'POST',
      desc: '移动图片',
      path: '/eleImg/moveImg'
    },
    {
      name: 'deleteVoiceEleCatalog',
      method: 'GET',
      desc: '删除音频分组',
      path: '/eleCatalog/deleteVoiceEleCatalog',
      append: true
    },
    {
      name: 'voiceCatalogList',
      method: 'GET',
      desc: '音频列表',
      path: '/eleCatalog/voiceCatalogList'
    },
    {
      name: 'addVoice',
      method: 'POST',
      desc: '音频上传',
      path: '/eleVoice/addVoice'
    },
    {
      name: 'deleteVoice',
      method: 'GET',
      desc: '删除音频',
      append: true,
      path: '/eleVoice/deleteVoice'
    },
    {
      name: 'moveVoice',
      method: 'POST',
      desc: '移动音频',
      path: '/eleVoice/removeVoice'
    },
    {
      name: 'renameVoice',
      method: 'POST',
      desc: '音频重命名',
      path: '/eleVoice/renameVoice'
    },
    {
      name: 'checkVoiceName',
      method: 'GET',
      desc: '校验音频重名',
      path: '/eleVoice/checkVoiceName'
    },
    {
      name: 'voiceList',
      method: 'GET',
      desc: '音频列表',
      path: '/eleVoice/voiceList'
    },
    /***
     * 视频
     */
    {
      name: 'deleteVideoEleCatalog',
      method: 'GET',
      desc: '删除视频分组',
      path: '/eleCatalog/deleteVideoEleCatalog',
      append: true
    },
    {
      name: 'videoCatalogList',
      method: 'GET',
      desc: '点击父级展示视频列表',
      path: '/eleCatalog/videoCatalogList'
    },
    {
      name: 'addVideo',
      method: 'POST',
      desc: '上传视频',
      path: '/eleVideo/addVideo'
    },
    {
      name: 'deleteVideo',
      method: 'GET',
      desc: '删除视频',
      append: true,
      path: '/eleVideo/deleteVideo'
    },
    {
      name: 'moveVideo',
      method: 'POST',
      desc: '移动视频',
      path: '/eleVideo/moveVideo'
    },
    {
      name: 'renameVideo',
      method: 'POST',
      desc: '视频重命名',
      path: '/eleVideo/renameVideo'
    },
    {
      name: 'checkVideoName',
      method: 'GET',
      desc: '校验视频重名',
      path: '/eleVideo/checkVideoName'
    },
    {
      name: 'videoList',
      method: 'GET',
      desc: '视频列表',
      path: '/eleVideo/videoList'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/cms/element.js